import React, { useState, useContext } from "react";
import AuthContext from "../AuthContext";
import AllUser from '../components/Users/AllUsers';
import AddUser from '../components/Users/AddUsers';
import UpdateUser from '../components/Users/UpdateUser';

function Inventory() {
  const [showProductModal, setShowProductModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateProduct, setUpdateProduct] = useState([]);
  const [updatePage, setUpdatePage] = useState(true);

  const authContext = useContext(AuthContext);


  // Modal for User ADD
  const addProductModalSetting = () => {
    setShowProductModal(!showProductModal);
  };

  // Modal for User UPDATE
  const updateProductModalSetting = (selectedProductData) => {
    setUpdateProduct(selectedProductData);
    setShowUpdateModal(!showUpdateModal);
  };

  // Handle Page Update
  const handlePageUpdate = () => {
    setUpdatePage(!updatePage);
  };

  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center">
      <div className="flex flex-col gap-5 w-11/12">
        
        {/* Add User Modal */}
        {showProductModal && (
          <AddUser
            addProductModalSetting={addProductModalSetting}
            handlePageUpdate={handlePageUpdate}
          />
        )}
        
        {/* Update User Modal */}
        {showUpdateModal && (
          <UpdateUser
            updateProductData={updateProduct}
            updateModalSetting={updateProductModalSetting}
            handlePageUpdate={handlePageUpdate}
          />
        )}

        {/* Table */}
        <div className="overflow-x-auto rounded-md bg-white border border-gray-200 shadow-lg">
          <div className="flex justify-between p-4 bg-gray-100 border-b border-gray-200">
            <h2 className="font-bold text-lg text-gray-700">All Users</h2>
            <button
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 text-sm rounded-sm shadow-md transition duration-300"
              onClick={addProductModalSetting}
            >
              Add New User
            </button>
          </div>
          <AllUser 
          userType={authContext.userType}
            updateProductModalSetting={updateProductModalSetting} 
            handlePageUpdate={handlePageUpdate} 
          />
        </div>
      </div>
    </div>
  );
}

export default Inventory;
